(function (Drupal, $) {
  Drupal.behaviors.faqs = {
    attach: function attach(context) {
      $('.field-item__field-faq-question, .plus-icon').click(function () {
        $('.paragraph--type--faq.open').not($(this).parent()).removeClass('open');
        $(this).parent().toggleClass('open');
      })
    }
  }
})(Drupal, jQuery);
